/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/16/20 2:19 PM
 */

import { configureStore } from "@reduxjs/toolkit";
import user, {UserState} from "./reducers/user";
import preferences, {Preferences} from "./reducers/preferences";
import calendar, {CalendarState} from "./reducers/calendar";
import employeesFilter, {EmployeesFilterState} from "./reducers/employees-filter";
import googleEvents, {GoogleEventsState} from "./reducers/google-events";
import settings, {SettingsState} from "./reducers/settings";
import favorites, {FavoritesState} from "./reducers/favorites";
import range, {RangeState} from "./reducers/range";
import recentEventTypes, {RecentEventTypesState} from "./reducers/recent-event-types";
import defaultCalendarId from "./reducers/default-calendar-id";
import slackUserTokenScopes from "./reducers/slack-user-token-scopes";

export interface State {
	calendar: CalendarState,
	employeesFilter: EmployeesFilterState,
	settings: SettingsState,
	googleEvents: GoogleEventsState,
	favorites: FavoritesState,
	range: RangeState,
	user: UserState,
	preferences: Preferences,
	recentEventTypes: RecentEventTypesState
	defaultCalendarId: number
	slackUserTokenScopes: string[]
}

export default configureStore({
	reducer: {
		calendar,
		employeesFilter,
		googleEvents,
		favorites,
		settings,
		range,
		user,
		preferences,
		recentEventTypes,
		defaultCalendarId,
		slackUserTokenScopes
	},
});